// 

//////divakar
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CustomList from './NDI_Main';
import Note from './NoteForm';
import Dialog from './DialogForm';
import Interaction from './InteractionForm';
import Url from './UrlForm';
import ReflectionForm from './RelectionForm';
import TakeawayForm from './TakeawayForm';
import OverviewForm from './OverviewForm'
import KeyInsightsForm from './KeyInsightsform';
import PreAssessmentForm from './PreAssessmentform';  
import PostAssessmentForm from './PostAssessmentForm';
import ScenarioCompletionForm from './ScenarioCompletionForm';
import SwipeMiniGameForm from './SwipeGameForm';
interface PropsInteraction {
  showReflectionQuestions?:any;
  id?: any;
  formData?: any;
  setBlockItems?: any;
  serias?: any;
  setserias?: any;
  setInput?: any;
  input?: any;
  setItems?: any;
  items?: any;
  alphabet?: any;
  setAlphabet?: any;
  interactionBlock?: any;
  setInteractionBlock?: any;
  countalphabet?: any;
  setAlphabetCount?: any;
  count?: any;
  setCount?: any;
  sequence?: any;
  setSequence?: any;
  dummySequence?: any;
  setDummySequence?: any;
  showSelectBlock?: any;
  setSelectBlock?: any;
  targetSequence?: any;
  handleKeyDown?: any;
  isDeleteSeq?: any;
  setDeleteseq?: any;
  handleGet?: any;
  fetchBlocks?: any;
  listQuest?: any;
  questTabState?: any;
  setQuestTabState?: any;
  deleteQuest?: any;
  upNextCount?: any;
  foundLastInput?: any;
  setUpNextCount?: any;
  reviews?: any;
  reviewers?: any;
  validation?: any;
  setValidation?: any;
  ShowReview?: any;
  listBlockItems?: any;
  languages?: any;
  handleMouseEnter: (review: any, index: number) => void;
  setScrollToElementEnabled: any;
  scrollToElementEnabled: any;
  setIsDeleteActionDone: any;
  chatNote: any;
  setChatNote: any;
  BlockItems:any;
  setUploadedFiles:React.Dispatch<
  React.SetStateAction<Record<string, File>>
>;
}

const Customize: React.FC<PropsInteraction> = ({
  showReflectionQuestions,
  id,
  formData,
  setBlockItems,
  serias,
  setserias,
  setInput,
  input,
  setItems,
  items,
  alphabet,
  setAlphabet,
  interactionBlock,
  setInteractionBlock,
  countalphabet,
  setAlphabetCount,
  count,
  setCount,
  sequence,
  setSequence,
  dummySequence,
  setDummySequence,
  showSelectBlock,
  setSelectBlock,
  targetSequence,
  handleKeyDown,
  isDeleteSeq,
  setDeleteseq,
  handleGet,
  fetchBlocks,
  listQuest,
  questTabState,
  setQuestTabState,
  deleteQuest,
  setUpNextCount,
  upNextCount,
  foundLastInput,
  reviewers,
  reviews,
  validation,
  setValidation,
  ShowReview,
  listBlockItems,
  languages,
  handleMouseEnter,
  setScrollToElementEnabled,
  scrollToElementEnabled,
  setIsDeleteActionDone,
  chatNote,
  setChatNote,
  setUploadedFiles,
  BlockItems,
}) => {
  const [showComponent, setComponent] = useState('CustomList');
  const navigate = useNavigate();

  const handleShowComponent = (componentName: string) => {
    setComponent(componentName);
  };
  return (
    <>
      {showComponent === 'CustomList' && (
        <CustomList
        showReflectionQuestions={showReflectionQuestions}
        BlockItems={BlockItems}
          handleShowComponent={handleShowComponent}
          id={id}
          formData={formData}
          setUploadedFiles={setUploadedFiles}
          setBlockItems={setBlockItems}
          serias={serias}
          setserias={setserias}
          setInput={setInput}
          input={input}
          setItems={setItems}
          items={items}
          alphabet={alphabet}
          setAlphabet={setAlphabet}
          interactionBlock={interactionBlock}
          setInteractionBlock={setInteractionBlock}
          countalphabet={countalphabet}
          setAlphabetCount={setAlphabetCount}
          count={count}
          setCount={setCount}
          sequence={sequence}
          setSequence={setSequence}
          dummySequence={dummySequence}
          setDummySequence={setDummySequence}
          showSelectBlock={showSelectBlock}
          setSelectBlock={setSelectBlock}
          targetSequence={targetSequence}
          handleKeyDown={handleKeyDown}
          isDeleteSeq={isDeleteSeq}
          setDeleteseq={setDeleteseq}
          handleGet={handleGet}
          fetchBlocks={fetchBlocks}
          listQuest={listQuest}
          questTabState={questTabState}
          setQuestTabState={setQuestTabState}
          deleteQuest={deleteQuest}
          upNextCount={upNextCount}
          foundLastInput={foundLastInput}
          setUpNextCount={setUpNextCount}
          reviews={reviews}
          reviewers={reviewers}
          validation={validation}
          setValidation={setValidation}
          ShowReview={ShowReview}
          listBlockItems={listBlockItems}
          languages={languages}
          handleMouseEnter={handleMouseEnter}
          setScrollToElementEnabled={setScrollToElementEnabled}
          scrollToElementEnabled={scrollToElementEnabled}
          setIsDeleteActionDone={setIsDeleteActionDone}
          chatNote={chatNote}
          setChatNote={setChatNote}
        />
      )}
      {showComponent === 'Note' && (
        <Note handleShowComponent={handleShowComponent} />
      )}
      {showComponent === 'Dialog' && (
        <Dialog handleShowComponent={handleShowComponent} />
      )}
      {showComponent === 'Link' && (
        <Url handleShowComponent={handleShowComponent} />
      )}
      {showComponent === 'Interaction' && (
        <Interaction handleShowComponent={handleShowComponent} />
      )}
      {showComponent === 'Reflection' && (
        <ReflectionForm handleShowComponent={handleShowComponent} />
      )}
      {showComponent === 'Takeaway' && (
        <TakeawayForm handleShowComponent={handleShowComponent} />
      )}
      {showComponent === 'Overview' && (
        <OverviewForm handleShowComponent={handleShowComponent} />
      )}
       {showComponent === 'KeyInsights' && (
        <KeyInsightsForm handleShowComponent={handleShowComponent} />
      )}
       {showComponent === 'SwipeMiniGame' && (
        <SwipeMiniGameForm handleShowComponent={handleShowComponent} />
      )}
       {showComponent === 'ScenarioCompletion' && (
        <ScenarioCompletionForm handleShowComponent={handleShowComponent} />
      )}
      {showComponent === 'PreAssessmen' && (
        <PreAssessmentForm handleShowComponent={handleShowComponent} />
      )}
      {showComponent === 'PostAssessment' && (
        <PostAssessmentForm handleShowComponent={handleShowComponent} />
      )}
    </>
  );
};

export default Customize;
